import { useSelector } from "react-redux";

import LanguageAwareExternalContent from "./LanguageAwareExternalContent";
import { type RootState } from "../../../redux/store";
import { Alert } from "~/common/m3/Alert/Alert";
import { SubstepType } from "~/Configurators/Linear/dtos";

const DesignationDisclaimer = () => {
  const content = useSelector(selectDisclaimerTextId);

  if (!content) {
    return null;
  }

  return (
    <div className={"mb-60"}>
      <Alert severity={"info"}>
        <LanguageAwareExternalContent content={content} />
      </Alert>
    </div>
  );
};

export default DesignationDisclaimer;

const selectDisclaimerTextId = (state: RootState) => {
  return state.linearConfigurator.substeps[SubstepType.SummaryPage].info;
};
